import { render, staticRenderFns } from "./AnimatedIcon.vue?vue&type=template&id=241ffd4a&scoped=true"
import script from "./AnimatedIcon.vue?vue&type=script&lang=js"
export * from "./AnimatedIcon.vue?vue&type=script&lang=js"
import style0 from "./AnimatedIcon.vue?vue&type=style&index=0&id=241ffd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241ffd4a",
  null
  
)

export default component.exports